import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import audioManager from '../utils/AudioManager';
import { saveAudioPlay } from '../utils/firebase';
import '../styles/InfoModal.css';

export default function InfoModal({ isOpen, onClose, info, sessionId }) {
  const { t } = useTranslation();
  // ★ 1回目:再生 → 2回目:停止 → 3回目:最初から再生、のトグル用state
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  // スポットが切り替わったら再生状態の表示もリセット
  useEffect(() => {
    setIsAudioPlaying(false);
  }, [info?.id]);

  if (!isOpen || !info) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handlePlayAudio = async () => {
    if (!info.audioPath) {
      console.warn('No audio path available for this spot');
      return;
    }

    // 再生中に押された場合は停止だけして終了
    if (isAudioPlaying) {
      audioManager.stop();
      setIsAudioPlaying(false);
      return;
    }

    // 停止中に押された場合は（1回目でも3回目でも）最初から再生
    setIsAudioPlaying(true);
    try {
      console.log('Playing audio from InfoModal:', info.audioPath);
      await audioManager.play(info.audioPath, {
        onEnded: () => setIsAudioPlaying(false)
      });
    } catch (error) {
      console.error('Failed to play audio from InfoModal:', error);
      // エラー時はシンプルモードで再試行
      audioManager.playSimple(info.audioPath, {
        onEnded: () => setIsAudioPlaying(false)
      });
    }

    // ★ 位置情報(saveLocation)と同じセッション単位で再生回数をカウント
    //    （失敗しても再生自体には影響させない）
    saveAudioPlay(sessionId, info.id).catch((err) => {
      console.error('Failed to record audio play count:', err);
    });
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="info-modal">
        <div className="info-content">
          <img src={info.image} alt={info.name} className="info-image" />
          
          <div className="info-header">
            <h2 className="info-title">{info.name}</h2>
            {/* 音声再生ボタン */}
            {info.audioPath && (
              <button 
                className="audio-play-button"
                onClick={handlePlayAudio}
                title={t('map.buttons.playAudio')}
                aria-pressed={isAudioPlaying}
              >
                {isAudioPlaying ? '⏸️' : '🔊'}
              </button>
            )}
          </div>
          
          <p className="info-description">{info.description}</p>
          {/* ★ 追加：経路検索ボタン */}
          {/* {info.onRouteSearch && (
            <button
              onClick={info.onRouteSearch}
              disabled={info.routeLoading}
              style={{
                marginTop: '12px',
                padding: '10px',
                width: '100%',
                borderRadius: '8px',
                border: 'none',
                background: '#ff4d4f',
                color: '#fff',
                fontWeight: 'bold',
                cursor: info.routeLoading ? 'not-allowed' : 'pointer'
              }}
            >
              {info.routeLoading ? '経路検索中...' : 'ここまでの経路'}
            </button>
          )} */}
        </div>
        
        <button className="close-button" onClick={onClose}>
          {t('map.buttons.close')}
        </button>
      </div>
    </div>
  );
}